module.exports = __webpack_public_path__ + "img/guardian_obese_reality.e651b979.png";